import React from 'react';
import moment from 'moment-timezone';

export const DateRenderer = props => {
  return (
    <React.Fragment>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <span>{moment.tz(props?.date, 'America/Los_Angeles').format('L')}</span>
      </div>
    </React.Fragment>
  );
};
